import ActivityBuilderInlineSvg from 'approot/shared/inline-svg/activity-builder/activity-builder-inline-svg';
import { ANSWER_LABELS } from './multiple-choice.constants';
import * as Styled from './multiple-choice.style';

export const MultipleChoiceLetter = ({ index }: { index: number }) => (
  <Styled.MultipleChoiceLetter>
    {`${ANSWER_LABELS[index]}.`}
  </Styled.MultipleChoiceLetter>
);

export const MultipleChoiceLetterImage = ({ index }: { index: number }) => (
  <Styled.MultipleChoiceImageLetter>
    {ANSWER_LABELS[index]}
  </Styled.MultipleChoiceImageLetter>
);

export const MultipleChoiceStatus = ({
  isCorrect,
  isIncorrect,
}: {
  isCorrect?: boolean;
  isIncorrect?: boolean;
}) => (
  <>
    {isCorrect && (
      <Styled.MultiChoiceCorrectIcon data-selector="revealed-answer-true">
        <ActivityBuilderInlineSvg id="icon_correct" width={36} height={36} />
      </Styled.MultiChoiceCorrectIcon>
    )}
    {isIncorrect && (
      <Styled.MultiChoiceCorrectIcon data-selector="revealed-answer-false">
        <ActivityBuilderInlineSvg id="icon_incorrect" width={36} height={36} />
      </Styled.MultiChoiceCorrectIcon>
    )}
  </>
);

export const MultipleChoiceListCorrect = () => (
  <Styled.MultiChoiceListCorrectIcon data-selector="revealed-answer-true">
    <ActivityBuilderInlineSvg id="icon_correct" width={24} height={24} />
  </Styled.MultiChoiceListCorrectIcon>
);

export const MultipleChoiceListIncorrect = () => (
  <Styled.MultiChoiceListCorrectIcon data-selector="revealed-answer-false">
    <ActivityBuilderInlineSvg id="icon_incorrect" width={24} height={24} />
  </Styled.MultiChoiceListCorrectIcon>
);
